export const APP_NAME = "Skillbit";
